module.exports = __webpack_public_path__ + "static/media/image-2.787fc0f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Neighborhood/image-2.png
// module id = 263
// module chunks = 0